import React, { useState } from "react";
import API from "../axiosInstance";
import "../styles/ModalPhoto.css";

export default function PhotoModal({ onClose }) {

  const [file, setFile] = useState(null);
  const [error, setError] = useState("");

  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  const email = currentUser?.email;

  const handleSubmit = async () => {
    try {
      if (!file) {
        setError("Choisis un fichier");
        return;
      }

      if (!email) {
        setError("Utilisateur non connecté");
        return;
      }

      const formData = new FormData();
      formData.append("profile_picture", file);
      formData.append("email", email);

      await API.post("/users/updatePhoto", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      window.location.reload();

    } catch (err) {
      console.error(err);
      setError("Erreur upload photo");
    }
  };

  return (
    <div className="modal-photo-overlay">
      <div className="modal-photo">

        <h2>Changer la photo</h2>

        <input
          type="file"
          accept="image/*"
          onChange={(e) => setFile(e.target.files[0])}
        />

        {error && <p style={{ color: "red" }}>{error}</p>}

        <div className="btn-zone">
          <button onClick={handleSubmit}>Valider</button>
          <button onClick={onClose}>Fermer</button>
        </div>

      </div>
    </div>
  );
}
